// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Ur4Y","footer":"ModalError_footer__1dfnt"};